export const checkRequiredFieldForDraft = (formData, openSnackbar) => {
  console.log(formData, "requiredfordraft");
  if (!formData.sessiondate) {
    //openSnackbar("Please fill in the session date", "error");
    return true;
  } else if (
    !formData.sessionstarttime ||
    !formData.sessionendtime ||
    formData.sessionstarttime.forma === "Invalid Date" ||
    formData.sessionendtime === "Invalid Date"
  ) {
    //openSnackbar("Please fill session time correctly", "error");
    return true;
  } else if (!formData.facilityid) {
    //openSnackbar("Please fill in the facility name", "error");
    return true;
  } else if (!formData.clientid) {
    //openSnackbar("Please fill in the client name", "error");
    return true;
  } else if (!formData.staffid) {
    //openSnackbar("Please fill in the staff name", "error");
    return true;
  } else if (!formData.supervisorid) {
    //openSnackbar("Please fill in the supervisor name", "error");
    return true;
  }
  return false;
};
